import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import Scrollspy from 'react-scrollspy';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import Profile from '../Profile';

import './SideBar.scss';

const SideBarItems = ({ items, isSideBarOpen, setIsSideBarOpen }) => {
  return (
    <Scrollspy
      offset={-5}
      items={items}
      componentTag="div"
      // rootEl=".wrapper > .content"
      className="list-group list-group-flush"
      currentClassName="active"
    >
      {items.map((item, idx) => (
        <Link
          key={idx}
          className="list-group-item list-group-item-action"
          to={`#${item}`}
          onClick={() => setIsSideBarOpen(!isSideBarOpen)}
        >
          {capitalize(item)}
        </Link>
      ))}
    </Scrollspy>
  );
};

function SideBar({
  id,
  sideBarItems,
  isSideBarOpen,
  setIsSideBarOpen,
  ...props
}) {
  const [profilePicUrl, setProfilePicUrl] = useState('');

  useEffect(() => {
    const fetchImg = async () => {
      const url = await fetch('./assets/images/me.png').then((res) => res.url);
      setProfilePicUrl(url);
    };
    fetchImg();
  }, []);

  console.log('profilePicUrl', profilePicUrl);

  return (
    <div id={id} className="d-flex flex-column" {...props}>
      <span
        className="btn-close-sidebar"
        onClick={() => setIsSideBarOpen(!isSideBarOpen)}
      >
        <i className="fas fa-times"></i>
      </span>
      <div className="user-field p-5">
        <Profile src={profilePicUrl} />
      </div>
      <Router forceRefresh={true}>
        <SideBarItems
          items={sideBarItems}
          isSideBarOpen={isSideBarOpen}
          setIsSideBarOpen={setIsSideBarOpen}
        />
      </Router>
    </div>
  );
}

SideBar.defaultProps = {
  id: 'sidebar',
};

SideBar.propTypes = {
  id: PropTypes.string,
};

export default React.memo(SideBar);
